/**
 * @generated SignedSource<<c5a982dc6becf256ae8a3254a969623b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type selfServiceSettingsSaveMutation$variables = {
  alertOnSlow: boolean;
  cutOffOK: boolean;
  cutoff?: number | null;
  name: string;
  startingDomain?: string | null;
  startingURL?: string | null;
  ujID: number;
};
export type selfServiceSettingsSaveMutation$data = {
  readonly setSelfServiceUJSettings: {
    readonly userJourney: {
      readonly " $fragmentSpreads": FragmentRefs<"selfServiceSettings_mainSettingsFragment">;
    } | null;
  } | null;
};
export type selfServiceSettingsSaveMutation = {
  response: selfServiceSettingsSaveMutation$data;
  variables: selfServiceSettingsSaveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "alertOnSlow"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cutOffOK"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cutoff"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startingDomain"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startingURL"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ujID"
},
v7 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "alertOnSlow",
        "variableName": "alertOnSlow"
      },
      {
        "kind": "Variable",
        "name": "cutOffOK",
        "variableName": "cutOffOK"
      },
      {
        "kind": "Variable",
        "name": "cutoff",
        "variableName": "cutoff"
      },
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "ujID"
      },
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "name"
      },
      {
        "kind": "Variable",
        "name": "startingDomain",
        "variableName": "startingDomain"
      },
      {
        "kind": "Variable",
        "name": "startingURL",
        "variableName": "startingURL"
      }
    ],
    "kind": "ObjectValue",
    "name": "ujData"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "selfServiceSettingsSaveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v7/*: any*/),
        "concreteType": "SelfServiceUJSettingsMutation",
        "kind": "LinkedField",
        "name": "setSelfServiceUJSettings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserJourney",
            "kind": "LinkedField",
            "name": "userJourney",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "selfServiceSettings_mainSettingsFragment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v6/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "selfServiceSettingsSaveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v7/*: any*/),
        "concreteType": "SelfServiceUJSettingsMutation",
        "kind": "LinkedField",
        "name": "setSelfServiceUJSettings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserJourney",
            "kind": "LinkedField",
            "name": "userJourney",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cutoff",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cutOffOK",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "alertOnSlow",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "journeyScribeStartingDomain",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "journeyScribeStartingDomainLocked",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "journeyScribeStartingURL",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "journeyScribeJourneyType",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "73103d3da6bef9b35bfc4eb02cf4066b",
    "id": null,
    "metadata": {},
    "name": "selfServiceSettingsSaveMutation",
    "operationKind": "mutation",
    "text": "mutation selfServiceSettingsSaveMutation(\n  $ujID: Int!\n  $name: String!\n  $cutoff: Int\n  $cutOffOK: Boolean!\n  $alertOnSlow: Boolean!\n  $startingDomain: String\n  $startingURL: String\n) {\n  setSelfServiceUJSettings(ujData: {id: $ujID, name: $name, cutoff: $cutoff, cutOffOK: $cutOffOK, alertOnSlow: $alertOnSlow, startingDomain: $startingDomain, startingURL: $startingURL}) {\n    userJourney {\n      ...selfServiceSettings_mainSettingsFragment\n      id\n    }\n  }\n}\n\nfragment selfServiceSettings_mainSettingsFragment on UserJourney {\n  id\n  name\n  cutoff\n  cutOffOK\n  alertOnSlow\n  journeyScribeStartingDomain\n  journeyScribeStartingDomainLocked\n  journeyScribeStartingURL\n  journeyScribeJourneyType\n}\n"
  }
};
})();

(node as any).hash = "fdc4c7bd1b13886ef2dc0358fecff5ef";

export default node;
